import React, { } from 'react';
import { Navigate } from 'react-router-dom';


export  const WebRoutes=[
      {
            path:'/article/:id',
            lazyComponent:()=>import('./portal/ArticlePage')
      },
      {
            path:'/trace/code/:id',
            lazyComponent:()=>import('./trace/code/TraceCodePage')
      },
];


